export const loadMobileResources = async (lng: string) => {
  switch (lng) {
    case "en":
      return (await import("../assets/language/en/mobile_web.json")).default;
    case "ca-ES":
      return (await import("../assets/language/ca-ES/mobile_web.json")).default;
    case "en-US":
      return (await import("../assets/language/en-US/mobile_web.json")).default;
    case "en-GB":
      return (await import("../assets/language/en-GB/mobile_web.json")).default;
    case "es-MX":
      return (await import("../assets/language/es-MX/mobile_web.json")).default;
    case "es-ES":
      return (await import("../assets/language/es-ES/mobile_web.json")).default;
    case "de-DE":
      return (await import("../assets/language/de-DE/mobile_web.json")).default;
    case "fr-FR":
      return (await import("../assets/language/fr-FR/mobile_web.json")).default;
    case "fr-CA":
      return (await import("../assets/language/fr-CA/mobile_web.json")).default;
    case "hi-IN":
      return (await import("../assets/language/hi-IN/mobile_web.json")).default;
    case "id-ID":
      return (await import("../assets/language/id-ID/mobile_web.json")).default;
    case "fil-PH":
      return (await import("../assets/language/fil-PH/mobile_web.json")).default;
    case "pl-PL":
      return (await import("../assets/language/pl-PL/mobile_web.json")).default;
    case "pt-BR":
      return (await import("../assets/language/pt-BR/mobile_web.json")).default;
    case "pt-PT":
      return (await import("../assets/language/pt-PT/mobile_web.json")).default;
    case "tr-TR":
      return (await import("../assets/language/tr-TR/mobile_web.json")).default;
    case "th-TH":
      return (await import("../assets/language/th-TH/mobile_web.json")).default;
    case "ru-RU":
      return (await import("../assets/language/ru-RU/mobile_web.json")).default;
    case "uk-UA":
      return (await import("../assets/language/uk-UA/mobile_web.json")).default;
    case "ar-AR":
      return (await import("../assets/language/ar-SA/mobile_web.json")).default;
    case "ar-SA":
      return (await import("../assets/language/ar-SA/mobile_web.json")).default;
    case "ko-KR":
      return (await import("../assets/language/ko-KR/mobile_web.json")).default;
    case "zh-CN":
      return (await import("../assets/language/zh-CN/mobile_web.json")).default;
    case "ja-JP":
      return (await import("../assets/language/ja-JP/mobile_web.json")).default;
    case "vi-VN":
      return (await import("../assets/language/vi-VN/mobile_web.json")).default;
    default:
      return (await import("../assets/language/en/mobile_web.json")).default;
  }
};
